"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakingPageQuery = void 0;
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n  .speakings {\n    padding: var(--gutter-large) 0;\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const layouts_1 = __importDefault(require("../layouts"));
const Talk_1 = __importDefault(require("../components/speaking/Talk"));
const styled_1 = __importDefault(require("@emotion/styled"));
var StyledSpeakingPage = styled_1.default.div(_templateObject());
exports.SpeakingPageQuery = "1840466851";
var SpeakingPage = function SpeakingPage(_ref) {
    var data = _ref.data;
    var speakings = data.allAirtable.nodes.map(function (t) {
        return {
            title: t.data.title,
            date: t.data.date,
            notes: t.data.notes ? t.data.notes.childMarkdownRemark.excerpt : null,
            slug: t.data.slug,
            slides: t.data.slides,
            organisation: (t.data.organisation ? t.data.organisation.map(function (o) {
                return o.data.title;
            }) : [])[0],
            tags: t.data.tags ? t.data.tags.map(function (t) {
                return t.data.name;
            }) : null
        };
    });
    return /*#__PURE__*/ react_1.default.createElement(layouts_1.default, null, /*#__PURE__*/ react_1.default.createElement(StyledSpeakingPage, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ react_1.default.createElement("section", null, /*#__PURE__*/ react_1.default.createElement("h1", null, "Speaking"), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "speakings container--small"
    }, speakings.map(function (talk, i) {
        return /*#__PURE__*/ react_1.default.createElement(Talk_1.default, Object.assign({
            key: i + talk.title
        }, talk));
    }))))));
};
exports.default = SpeakingPage;
